<app-pagination [total]="total" [limit]="limit" (page)="load($event.from)"></app-pagination>
<app-assessment-test *ngFor="let assessment of assessments" [assessment]="assessment" mode="list"></app-assessment-test>